<template>
  <div style="position: relative;">
    <pre
      style="white-space: break-spaces; background: #23241f;"
      :class="! language ? 'no-language' : null"
    >
<v-btn
  ref="copyBtn"
  fab
  small
  icon
  dark
  style="position: absolute; top: 0; right: 0;"
  :data-clipboard-text="code"
><v-icon>mdi-content-copy</v-icon></v-btn><code
:key="key"
    :class="language ? `language-${language}` : null"
    >{{ code }}</code></pre>
  </div>
</template>

<script>
export default {
  props: {
    language: {
      type: String,
      required: false,
      default: null
    },
    code: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      key: 0,
      clipboard: null
    }
  },

  watch: {
    code: function() {
      this.key++;
      this.highlight();
    }
  },

  mounted() {
    if (this.language) {
      this.highlight();
    }
    this.initializeClipboardJs();
  },

  methods: {
    highlight() {
      this.$nextTick(() => {
        window.hljs.highlightBlock(this.$el.querySelector('code'));
      });
    },

    initializeClipboardJs() {
      this.clipboard = new window.ClipboardJS(this.$refs.copyBtn.$el);

      this.clipboard.on('success', e => {
        this.$emit('copy-success');
        e.clearSelection();
      });

      this.clipboard.on('error', () => {
        this.$emit('copy-error');
      });
    }
  }
}
</script>

<style>
code { color: #fff !important; }
code span::-moz-selection , pre code::-moz-selection { background: var(--v-primary-base); color: #fff !important; }
code span::selection, pre code::selection { background: var(--v-primary-base); color: #fff !important; }
pre.no-language { padding: .75em !important; }
pre.no-language code { color: #ebff87 !important; font-size: 1em; }
</style>